import { useEffect } from "react";
import { Table} from '@deere/ux.uxframe-react'
import { Checkbox } from '@mui/material';
import { useTranslation } from "react-i18next";
import { getRequestStatusWhenCampaignClosed } from '../../utils/utils';

export const SupplierGroup = ({ list, onCheck, onCheckAll, selectedSuppliers, campaign, sx }) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (list.length === 1 && selectedSuppliers.length === 0) {
          const event = { target: { checked: true } };
          onCheckAll(event);
        }
      }, [list.length, selectedSuppliers.length]);

    const isSelected = (currSupplier) => {
        return (selectedSuppliers.includes(`${currSupplier.supplierNumber}-${currSupplier.id}`) || currSupplier.groupNumber?true:false);
    }
    const isCheckAllSelected = () => {
        let checkAll = true;
        list.forEach((l)=>{
            const index = selectedSuppliers.findIndex((ss) => ss === `${l.supplierNumber}-${l.id}`);
            if(index === -1)    checkAll = false;
        })
        return checkAll;
    };

    let tableRowStyle;
    if(sx){
        tableRowStyle = sx.tableRowStyle;
    }
    
    const isDisabled = (groupNumber) => {
        if (list.length === 1) {
          return true;
        } else {
          return !!groupNumber ? true : false;
        }
    };

    return (
        <div>
            <Table  responsive size="sm">
                <thead>
                    <tr>
                        <th scope="col" className="text-left" style={tableRowStyle}><Checkbox onChange={onCheckAll} disabled={list.length === 1} checked={isCheckAllSelected()}/>{t('cm_lbl_supplier')}</th>
                        <th scope="col" className="text-left"></th>
                    </tr>
                </thead>
                <tbody>
                    {
                         list.map((supp, index) =>
                         <tr id={index} key={index}>
                            <td className="text-left" style={tableRowStyle}><Checkbox onChange={onCheck} checked={isSelected(supp)} value={`${supp.supplierNumber}-${supp.id}`} disabled={isDisabled(supp.groupNumber)}/>
                                {supp.supplierNumber} - {supp.supplierName} (Request {supp.id} Status: {supp && campaign ? getRequestStatusWhenCampaignClosed(supp.status, campaign.status) : ""})
                            </td>
                            <td className="text-left"></td>
                        </tr>
                     )
                    }
                </tbody>
            
            </Table>
        </div>
      );
}